// Copyright (c) 2017 TrainHeroic LLC
// Actions for User/athlete/coach

import APP_ACTIONS from './app/actions';
import AUTH_ACTIONS from './auth/actions';

const ACTIONS = Object.assign({}, APP_ACTIONS, AUTH_ACTIONS);

export default ACTIONS;
